/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function(){

    $('.link1').click(function () {
        $(this).toggleClass('open');
        $('#toggleCnt1').slideToggle(1000)
    });  
    $('.link2').click(function () {
        $(this).toggleClass('open');
        $('#toggleCnt2').slideToggle(1000)
    });  
    $('.link3').click(function () {
        $(this).toggleClass('open');
        $('#toggleCnt3').slideToggle(1000)
    });  
    $('.link4').click(function () {
        $(this).toggleClass('open');
        $('#toggleCnt4').slideToggle(1000)
    });  

});

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].relList.add('noreferrer', 'noopener');
  }
}

// animations
function animation_library_auzen() {
    /*
     * use this class for anime you DOMElement, WARNING add attribut speed for speed if you don't add speed atribut with a number this not
     * exemple: <div class="to_bot" speed="5">YOUR CONTENT</div>
     */

    var to_bot = document.querySelectorAll('.to_bot'),
        to_top = document.querySelectorAll('.to_top'),
        to_right = document.querySelectorAll('.to_right'),
        to_left = document.querySelectorAll('.to_left'),
        all = [to_bot, to_top, to_right, to_left];
        
    if (window.location.href === 'https://auzen.com/pages/ressources#block-page-faq-template-0' || window.location.href === 'https://auzen.com/pages/ressources' ||  window.location.href === 'https://auzen.com/pages/ressources#block-1611077640388') {
        document.querySelectorAll('.Faq .to_top').forEach(e => {
            e.style.transition = '1s'
            e.style.opacity = '1'
        })
    } else {
        if (window.innerWidth > 1024) {

            to_bot.length > 0 ? gsap.set(to_bot, {
                opacity: 0,
                y: -20
            }) : ''

            to_top.length > 0 ? gsap.set(to_top, {
                opacity: 0,
                y: 20
            }) : ''

            to_right.length > 0 ? gsap.set(to_right, {
                opacity: 0,
                x: 20
            }) : ''

            to_left.length > 0 ? gsap.set(to_left, {
                opacity: 0,
                x: -20
            }) : ''

        } else {
            console.log('vous etes sur mobile les animation sont desactiver')
        }

        function animation(target) {
            var has = target.classList;
            var time = target.getAttribute("speed") != null ? target.getAttribute("speed") : 1

            switch (true) {
                case has.contains('to_bot'):
                    gsap.to(target, {
                        duration: time,
                        y: 0,
                        opacity: 1
                    })
                    break
                case has.contains('to_top'):
                    gsap.to(target, {
                        duration: time,
                        y: 0,
                        opacity: 1
                    })
                    break
                case has.contains('to_left'):
                    gsap.to(target, {
                        duration: time,
                        x: 0,
                        opacity: 1
                    })
                    break
                case has.contains('to_right'):
                    gsap.to(target, {
                        duration: time,
                        x: 0,
                        opacity: 1
                    })
                    break
            }
        }

        function observer_animation(entries, observer) {
            entries.forEach(entry => {
                if (entry.isIntersecting === true || entry.isVisible === true) {
                    animation(entry.target);
                }
            });
        };

        var options = {
            root: null,
            threshold: 0.3
        };

        var observer = new IntersectionObserver(observer_animation, options);

        all.forEach(function (el) {
            el.forEach(function (anime) {
                observer.observe(anime)
            });
        });
    }

}

animation_library_auzen(); 

function offset(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

function initDrawersScrolling() {
    let sectionHeader = document.getElementById('section-header');
    let tabDrawerHeadings = document.getElementsByClassName('tab_drawer_heading');

    if (sectionHeader != undefined && tabDrawerHeadings.length > 0) {
        for (const element of tabDrawerHeadings) {
            let rel = element.getAttribute('rel');
    
            element.addEventListener('click', function() { 
                let elementOffset = offset(document.getElementById(rel));
    
                window.scrollTo(0, elementOffset.top - sectionHeader.offsetHeight - element.offsetHeight);
            });
        }
    }
}

if (window.innerWidth < 1008) {
    initDrawersScrolling();
    document.getElementById('header_rdv_a').href="tel:+4932221099558";
    document.getElementById('header_rdv_svg').innerHTML='<use xlink:href="#telephone"></use>';
}

function isMobile() {
    return window.innerWidth <= 600; 
}
